// Guesses the platform from a pasted URL so people rarely have to pick a
// type by hand. Returns one of the link types, 'custom' when nothing matches.
const HOSTS = [
  [/(^|\.)instagram\.com$/, 'instagram'],
  [/(^|\.)tiktok\.com$/, 'tiktok'],
  [/(^|\.)(youtube\.com|youtu\.be)$/, 'youtube'],
  [/(^|\.)(twitter\.com|x\.com)$/, 'twitter'],
  [/(^|\.)(wa\.me|whatsapp\.com)$/, 'whatsapp'],
  [/(^|\.)spotify\.com$/, 'spotify']
];

const detectLinkType = (raw) => {
  const value = String(raw || '').trim();
  if (/^mailto:/i.test(value) || /^[^\s@/:]+@[^\s@/:]+\.[^\s@/:]+$/.test(value)) return 'email';
  let host = '';
  try {
    host = new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(value) ? value : 'https://' + value).hostname.toLowerCase();
  } catch (e) {
    return 'custom';
  }
  const match = HOSTS.find(([pattern]) => pattern.test(host));
  return match ? match[1] : 'custom';
};

export default detectLinkType;
